import { gql } from "@apollo/client";
export const UpdateBankAccountBalance = gql `
  mutation UpdateBankAccountBalance($input: UpdateBankAccountBalanceInput!) {
    UpdateBankAccountBalance(input: $input)
  }
`;
